<template>
	<el-container class="home-container">
		<gg-toubu></gg-toubu>

		<el-main>
			<mianban yangshi="panel-primary" class="mb-10">
				<div slot="header">
					<el-tag class="f-16" size="medium" effect="light">我的应用</el-tag>
					<el-button v-on:click="我的应用()" class="f-16 f-r" size="mini" type="success">刷新</el-button>
				</div>
				<div>
					<table class="table">
						<tr>
							<td v-for="yy in 应用数据" :key="yy.应用编号" class="f-l text-c" width="76px">
								<el-link :underline="false" :href="yy.电脑浏览器链接地址" target="_blank">
									<el-avatar shape="square" :size="64" :src="yy.图片地址"></el-avatar>
									<br />
									<span class="f-12">{{ yy.标题 }}</span>
								</el-link>
							</td>
						</tr>
					</table>
				</div>
			</mianban>

			<el-divider>
				<el-tag class="f-16" size="medium" effect="light">待办</el-tag>
			</el-divider>

			<el-row>
				<el-col :lg="12" v-if="隐藏拖欠费用待办">
					<mianban header="拖欠费用待办" yangshi="panel-primary" class="mr-10 mb-10">
						<template>
							<el-table :data="拖欠费用数据.数据" style="width: 99.9%;overflow: hidden;" class="f-12">
								<el-table-column label="序号" min-width="40">
									<template slot-scope="scope">
										<div>{{ scope.$index + 1 + (拖欠费用数据.页数 - 1) * 10 }}</div>
									</template>
								</el-table-column>
								<el-table-column label="订单编号" min-width="95">
									<template slot-scope="scope">
										<div class="c-red">{{ scope.row.订单编号 }}</div>
									</template>
								</el-table-column>
								<el-table-column label="客户名称" min-width="140">
									<template slot-scope="scope">
										<div>{{ scope.row.客户名称 }}</div>
									</template>
								</el-table-column>
								<el-table-column label="结束日期" min-width="90">
									<template slot-scope="scope">
										<div>{{ scope.row.结束日期.slice(0, 10) }}</div>
									</template>
								</el-table-column>
								<el-table-column label="超时" min-width="60">
									<template slot-scope="scope">
										<div class="c-red">{{ scope.row.超时 + '天' }}</div>
									</template>
								</el-table-column>
								<el-table-column label="应收费用" min-width="75">
									<template slot-scope="scope">
										<div class="c-blue">{{ scope.row.应收费用 }}</div>
									</template>
								</el-table-column>
								<el-table-column label="实际收款" min-width="65">
									<template slot-scope="scope">
										<div class="c-blue">{{ scope.row.实际收款金额 }}</div>
									</template>
								</el-table-column>
								<el-table-column label="欠费" min-width="75">
									<template slot-scope="scope">
										<div class="c-blue">{{ scope.row.欠费 }}</div>
									</template>
								</el-table-column>
							</el-table>
							<el-pagination background layout="total, prev, pager, next" :total="拖欠费用数据.总数" :pager-count="7"
								@current-change="tuoqianfeiyongdaiban_tiaozhuan" prev-text="上一页" next-text="下一页"></el-pagination>
						</template>
					</mianban>
				</el-col>

				<el-col :lg="12" v-if="隐藏我的待办&&不显示">
					<mianban header="我的待办" yangshi="panel-primary" class="mr-10 mb-10">
						<template>
							<el-table :data="我的待办数据.数据" style="width: 99.9%;overflow: hidden;" class="f-12">
								<el-table-column label="序号" min-width="50">
									<template slot-scope="scope">
										<span>{{ scope.$index + 1 + (我的待办数据.页数 - 1) * 10 }}</span>
									</template>
								</el-table-column>
								<el-table-column label="编号" min-width="90">
									<template slot-scope="scope">
										<span>{{ scope.row.编号 }}</span>
									</template>
								</el-table-column>
								<el-table-column label="待办来源" min-width="90">
									<template slot-scope="scope">
										<span>{{ scope.row.待办来源 }}</span>
									</template>
								</el-table-column>
								<el-table-column label="待办标题	" min-width="90">
									<template slot-scope="scope">
										<span>{{ scope.row.待办标题 }}</span>
									</template>
								</el-table-column>
								<el-table-column label="提交时间" min-width="100">
									<template slot-scope="scope">
										<i class="el-icon-time"></i>
										<span style="margin-left: 10px">{{ scope.row.提交时间.slice(0, 10) }}</span>
									</template>
								</el-table-column>
								<el-table-column label="提交人	" min-width="90">
									<template slot-scope="scope">
										<span>{{ scope.row.提交人 }}</span>
									</template>
								</el-table-column>
							</el-table>
							<el-pagination background layout="total, prev, pager, next" :total="我的待办数据.总数" :pager-count="7"
								@current-change="wodedaiban_tiaozhuan" prev-text="上一页" next-text="下一页">
							</el-pagination>
						</template>
					</mianban>
				</el-col>

				<el-col :lg="12" v-if="隐藏订单审核待办">
					<mianban header="订单审核待办" yangshi="panel-primary" class="mr-10 mb-10">
						<template>
							<el-table :data="订单审核待办数据.数据" style="width: 99.9%;overflow: hidden;" class="f-12">
								<el-table-column label="序号" min-width="40">
									<template slot-scope="scope">
										<span>{{ scope.$index + 1 + (订单审核待办数据.页数 - 1) * 10 }}</span>
									</template>
								</el-table-column>
								<el-table-column label="订单编号" min-width="140">
									<template slot-scope="scope">
										<span class="c-red">{{ scope.row.业务员 + scope.row.订单编号 }}</span>
									</template>
								</el-table-column>
								<el-table-column label="客户名称" min-width="140">
									<template slot-scope="scope">
										<span>{{ scope.row.客户名称 }}</span>
									</template>
								</el-table-column>
								<el-table-column label="发车日期" min-width="90">
									<template slot-scope="scope">
										<span>{{ scope.row.发车日期.slice(0, 10) }}</span>
									</template>
								</el-table-column>
								<el-table-column label="订单分类" min-width="80">
									<template slot-scope="scope">
										<span>{{ scope.row.订单分类 }}</span>
									</template>
								</el-table-column>
								<el-table-column label="订单状态" min-width="80">
									<template slot-scope="scope">
										<el-tag size="medium" type="info" effect="dark">{{ scope.row.订单状态 }}</el-tag>
									</template>
								</el-table-column>
							</el-table>
							<el-pagination background layout="total, prev, pager, next" :total="订单审核待办数据.总数" :pager-count="7"
								@current-change="dingdanshenhedaiban_tiaozhuan" prev-text="上一页" next-text="下一页"></el-pagination>
						</template>
					</mianban>
				</el-col>

				<el-col :lg="12" v-if="隐藏待排订单待办&&不显示">
					<mianban header="待排订单待办" yangshi="panel-primary" class="mr-10 mb-10">
						<template>
							<el-table :data="待排订单待办数据.数据" style="width: 99.9%;overflow: hidden;" class="f-12">
								<el-table-column label="序号" min-width="40">
									<template slot-scope="scope">
										<span>{{ scope.$index + 1 + (待排订单待办数据.页数 - 1) * 10 }}</span>
									</template>
								</el-table-column>
								<el-table-column label="订单编号" min-width="140">
									<template slot-scope="scope">
										<span>{{ scope.row.业务员 + scope.row.订单编号 }}</span>
									</template>
								</el-table-column>
								<el-table-column label="客户名称" min-width="140">
									<template slot-scope="scope">
										<span>{{ scope.row.客户名称 }}</span>
									</template>
								</el-table-column>
								<el-table-column label="发车日期" min-width="90">
									<template slot-scope="scope">
										<span>{{ scope.row.发车日期.slice(0, 10) }}</span>
									</template>
								</el-table-column>
								<el-table-column label="车辆分类	" min-width="80">
									<template slot-scope="scope">
										<span>{{ scope.row.车辆分类 }}</span>
									</template>
								</el-table-column>
								<el-table-column label="座位需求	" min-width="50">
									<template slot-scope="scope">
										<span>{{ scope.row.座位需求 }}</span>
									</template>
								</el-table-column>
								<el-table-column label="排单状态" min-width="80">
									<template slot-scope="scope">
										<el-tag size="medium" type="info" effect="dark">{{ scope.row.排单状态 }}</el-tag>
									</template>
								</el-table-column>
							</el-table>
							<el-pagination background layout="total, prev, pager, next" :total="待排订单待办数据.总数" :pager-count="7"
								@current-change="daipaidingdandaiban_tiaozhuan" prev-text="上一页" next-text="下一页"></el-pagination>
						</template>
					</mianban>
				</el-col>

				<el-col :lg="12" v-if="隐藏年审待办">
					<mianban header="年审待办" yangshi="panel-primary" class="mr-10 mb-10">
						<template>
							<el-table :data="年审待办数据.数据" style="width: 99.9%;overflow: hidden;" class="f-12">
								<el-table-column label="序号" min-width="50">
									<template slot-scope="scope">
										<span>{{ scope.$index + 1 + (年审待办数据.页数 - 1) * 10 }}</span>
									</template>
								</el-table-column>
								<el-table-column label="车牌号码" min-width="120">
									<template slot-scope="scope">
										<span class="c-red">{{ scope.row.车牌号码 }}</span>
									</template>
								</el-table-column>
								<el-table-column label="年检时间" min-width="90">
									<template slot-scope="scope">
										<span>{{ scope.row.年检时间 }}</span>
									</template>
								</el-table-column>
								<el-table-column label="超时	" min-width="50">
									<template slot-scope="scope">
										<span class="c-red">{{ scope.row.超时 }}天</span>
									</template>
								</el-table-column>
								<el-table-column label="车辆分类" min-width="80">
									<template slot-scope="scope">
										<el-tag size="medium" type="info">{{ scope.row.车辆分类 }}</el-tag>
									</template>
								</el-table-column>
							</el-table>
							<el-pagination background layout="total, prev, pager, next" :total="年审待办数据.总数" :pager-count="7"
								@current-change="nianshendaiban_tiaozhuan" prev-text="上一页" next-text="下一页"></el-pagination>
						</template>
					</mianban>
				</el-col>

				<el-col :lg="12" v-if="隐藏交强险待办">
					<mianban header="交强险待办" yangshi="panel-primary" class="mr-10 mb-10">
						<template>
							<el-table :data="交强险待办数据.数据" style="width: 99.9%;overflow: hidden;" class="f-12">
								<el-table-column label="序号" min-width="40">
									<template slot-scope="scope">
										<span>{{ scope.$index + 1 + (交强险待办数据.页数 - 1) * 10 }}</span>
									</template>
								</el-table-column>
								<el-table-column label="车牌号码" min-width="100">
									<template slot-scope="scope">
										<span class="c-red">{{ scope.row.车牌号码 }}</span>
									</template>
								</el-table-column>
								<el-table-column label="交强险结束日期" min-width="90">
									<template slot-scope="scope">
										<span>{{ scope.row.交强险结束日期 }}</span>
									</template>
								</el-table-column>
								<el-table-column label="超时	" min-width="60">
									<template slot-scope="scope">
										<span class="c-red">{{ scope.row.超时 }}天</span>
									</template>
								</el-table-column>
								<el-table-column label="车辆分类" min-width="80">
									<template slot-scope="scope">
										<el-tag size="medium" type="info">{{ scope.row.车辆分类 }}</el-tag>
									</template>
								</el-table-column>
							</el-table>
							<el-pagination background layout="total, prev, pager, next" :total="交强险待办数据.总数" :pager-count="7"
								@current-change="jiaoqiangxian_daiban_tiaozhuan" prev-text="上一页" next-text="下一页"></el-pagination>
						</template>
					</mianban>
				</el-col>

				<el-col :lg="12" v-if="隐藏商业险待办">
					<mianban header="商业险待办" yangshi="panel-primary" class="mr-10 mb-10">
						<template>
							<el-table :data="商业险待办数据.数据" style="width: 99.9%;overflow: hidden;" class="f-12">
								<el-table-column label="序号" min-width="40">
									<template slot-scope="scope">
										<span>{{ scope.$index + 1 + (商业险待办数据.页数 - 1) * 10 }}</span>
									</template>
								</el-table-column>
								<el-table-column label="车牌号码" min-width="100">
									<template slot-scope="scope">
										<span class="c-red">{{ scope.row.车牌号码 }}</span>
									</template>
								</el-table-column>
								<el-table-column label="商业险结束日期" min-width="90">
									<template slot-scope="scope">
										<span>{{ scope.row.商业险结束日期 }}</span>
									</template>
								</el-table-column>
								<el-table-column label="超时	" min-width="60">
									<template slot-scope="scope">
										<span class="c-red">{{ scope.row.超时 }}天</span>
									</template>
								</el-table-column>
								<el-table-column label="车辆分类" min-width="80">
									<template slot-scope="scope">
										<el-tag size="medium" type="info">{{ scope.row.车辆分类 }}</el-tag>
									</template>
								</el-table-column>
							</el-table>
							<el-pagination background layout="total, prev, pager, next" :total="商业险待办数据.总数" :pager-count="7"
								@current-change="shangyexian_daiban_tiaozhuan" prev-text="上一页" next-text="下一页"></el-pagination>
						</template>
					</mianban>
				</el-col>

				<el-col :lg="12" v-if="隐藏承运险待办">
					<mianban header="承运险待办" yangshi="panel-primary" class="mr-10 mb-10">
						<template>
							<el-table :data="承运险待办数据.数据" style="width: 99.9%;overflow: hidden;" class="f-12">
								<el-table-column label="序号" min-width="40">
									<template slot-scope="scope">
										<span>{{ scope.$index + 1 + (承运险待办数据.页数 - 1) * 10 }}</span>
									</template>
								</el-table-column>
								<el-table-column label="车牌号码" min-width="100">
									<template slot-scope="scope">
										<span class="c-red">{{ scope.row.车牌号码 }}</span>
									</template>
								</el-table-column>
								<el-table-column label="承运险结束日期" min-width="90">
									<template slot-scope="scope">
										<span>{{ scope.row.承运险结束日期 }}</span>
									</template>
								</el-table-column>
								<el-table-column label="超时	" min-width="60">
									<template slot-scope="scope">
										<span class="c-red">{{ scope.row.超时 }}天</span>
									</template>
								</el-table-column>
								<el-table-column label="车辆分类" min-width="80">
									<template slot-scope="scope">
										<el-tag size="medium" type="info">{{ scope.row.车辆分类 }}</el-tag>
									</template>
								</el-table-column>
							</el-table>
							<el-pagination background layout="total, prev, pager, next" :total="承运险待办数据.总数" :pager-count="7"
								@current-change="chengyunxian_daiban_tiaozhuan" prev-text="上一页" next-text="下一页"></el-pagination>
						</template>
					</mianban>
				</el-col>

				<el-col :lg="12" v-if="隐藏长租合同到期待办">
					<mianban header="长租合同到期待办" yangshi="panel-primary" class="mr-10 mb-10">
						<template>
							<el-table :data="长租合同到期待办数据.数据" style="width: 99.9%;overflow: hidden;" class="f-12">
								<el-table-column label="序号" min-width="40">
									<template slot-scope="scope">
										<div>{{ scope.$index + 1 + (长租合同到期待办数据.页数 - 1) * 10 }}</div>
									</template>
								</el-table-column>
								<el-table-column label="订单编号" min-width="95">
									<template slot-scope="scope">
										<div class="c-red">{{ scope.row.订单编号 }}</div>
									</template>
								</el-table-column>
								<el-table-column label="客户名称" min-width="140">
									<template slot-scope="scope">
										<div>{{ scope.row.客户名称 }}</div>
									</template>
								</el-table-column>
								<el-table-column label="结束日期" min-width="90">
									<template slot-scope="scope">
										<div>{{ scope.row.结束日期.slice(0, 10) }}</div>
									</template>
								</el-table-column>
								<el-table-column label="超时" min-width="60">
									<template slot-scope="scope">
										<div class="c-red">{{ scope.row.超时 + '天' }}</div>
									</template>
								</el-table-column>
								<el-table-column label="应收费用" min-width="75">
									<template slot-scope="scope">
										<div class="c-blue">{{ scope.row.应收费用 }}</div>
									</template>
								</el-table-column>
								<el-table-column label="实际收款" min-width="65">
									<template slot-scope="scope">
										<div class="c-blue">{{ scope.row.实际收款金额 }}</div>
									</template>
								</el-table-column>
								<el-table-column label="欠费" min-width="75">
									<template slot-scope="scope">
										<div class="c-blue">{{ scope.row.欠费 }}</div>
									</template>
								</el-table-column>
								<el-table-column label="欠费" min-width="75">
									<template slot-scope="scope">
										<el-button size="mini" type="danger" @click="长租合同到期待办忽略(scope.row.订单编号)">忽略</el-button>
									</template>
								</el-table-column>
							</el-table>
							<el-pagination background layout="total, prev, pager, next" :total="长租合同到期待办数据.总数" :pager-count="7"
								@current-change="changzuhetong_daiban_tiaozhuan" prev-text="上一页" next-text="下一页"></el-pagination>
						</template>
					</mianban>
				</el-col>

				<!-- <el-col :lg="12" v-if="隐藏GPS充值待办">
							<mianban header="GPS充值待办" yangshi="panel-primary" class="mr-10 mb-10">
								<template>
									<el-table :data="GPS充值待办数据.数据" style="width: 99.9%;overflow: hidden;" class="f-12">
										<el-table-column label="序号" min-width="50">
											<template slot-scope="scope">
												<span>{{ scope.$index + 1 + (GPS充值待办数据.页数 - 1) * 10 }}</span>
											</template>
										</el-table-column>
										<el-table-column label="车牌号" min-width="120">
											<template slot-scope="scope">
												<span class="c-red">{{ scope.row.车牌号 }}</span>
											</template>
										</el-table-column>
										<el-table-column label="充值时间" min-width="90">
											<template slot-scope="scope">
												<span>{{ scope.row.充值时间 }}</span>
											</template>
										</el-table-column>
										<el-table-column label="到期日期" min-width="90">
											<template slot-scope="scope">
												<span>{{ scope.row.到期日期 }}</span>
											</template>
										</el-table-column>
										<el-table-column label="联系人电话" min-width="110">
											<template slot-scope="scope">
												<span>{{ scope.row.联系人电话 }}</span>
											</template>
										</el-table-column>
										<el-table-column label="超时	" min-width="50">
											<template slot-scope="scope">
												<span class="c-red">{{ scope.row.超时 }}</span>
											</template>
										</el-table-column>
									</el-table>
									<el-pagination
										background
										layout="total, prev, pager, next"
										:total="GPS充值待办数据.总数"
										:pager-count="7"
										@current-change="gpschongzhidaiban_tiaozhuan"
										prev-text="上一页"
										next-text="下一页"
									></el-pagination>
								</template>
							</mianban>
						</el-col> -->

				<!-- <el-col :lg="12" v-if="隐藏客户合同待办">
							<mianban header="客户合同待办" yangshi="panel-primary" class="mr-10 mb-10">
								<template>
									<el-table :data="客户合同待办数据.数据" style="width: 99.9%;overflow: hidden;" class="f-12">
										<el-table-column label="序号" min-width="50">
											<template slot-scope="scope">
												<span>{{ scope.$index + 1 + (客户合同待办数据.页数 - 1) * 10 }}</span>
											</template>
										</el-table-column>
										<el-table-column label="客户简称" min-width="140">
											<template slot-scope="scope">
												<span>{{ scope.row.客户简称 }}</span>
											</template>
										</el-table-column>
										<el-table-column label="结束日期" min-width="90">
											<template slot-scope="scope">
												<span>{{ scope.row.客户合同结束日期 }}</span>
											</template>
										</el-table-column>
										<el-table-column label="超时	" min-width="50">
											<template slot-scope="scope">
												<span>{{ scope.row.超时 }}</span>
											</template>
										</el-table-column>
										<el-table-column label="负责人" min-width="80">
											<template slot-scope="scope">
												<el-tag size="medium" effect="dark">{{ scope.row.负责人 }}</el-tag>
											</template>
										</el-table-column>
									</el-table>
									<el-pagination
										background
										layout="total, prev, pager, next"
										:total="客户合同待办数据.总数"
										:pager-count="7"
										@current-change="kehuhetongdaiban_tiaozhuan"
										prev-text="上一页"
										next-text="下一页"
									></el-pagination>
								</template>
							</mianban>
						</el-col> -->

			</el-row>
		</el-main>
		<el-footer height="30px">
			<gg-dibu></gg-dibu>
		</el-footer>
	</el-container>
</template>

<script>
	export default {
		data() {
			return {
				不显示: false,
				应用数据: '',
				拖欠费用数据: '',
				我的待办数据: '',
				订单审核待办数据: '',
				待排订单待办数据: '',
				年审待办数据: '',
				投保待办数据: '',
				GPS充值待办数据: '',
				客户合同待办数据: '',
				交强险待办数据: '',
				商业险待办数据: '',
				承运险待办数据: '',
				长租合同到期待办数据: '',
				隐藏拖欠费用待办: true,
				隐藏我的待办: true,
				隐藏订单审核待办: true,
				隐藏待排订单待办: true,
				隐藏年审待办: true,
				隐藏投保待办: true,
				隐藏GPS充值待办: true,
				隐藏客户合同待办: true,
				隐藏交强险待办: true,
				隐藏商业险待办: true,
				隐藏承运险待办: true,
				隐藏长租合同到期待办: true,
				长租合同到期待办当前页:1,
			};
		},
		created: function() {
			this.我的应用();
			this.拖欠费用待办(1);
			this.我的待办(1);
			this.订单审核待办(1);
			this.待排订单待办(1);
			this.年审待办(1);
			this.交强险待办(1);
			this.商业险待办(1);
			this.承运险待办(1);
			this.长租合同到期待办(1);
			// this.投保待办(1);
			/* this.GPS充值待办(1);
			this.客户合同待办(1); */
		},
		methods: {
			长租合同到期待办忽略(订单编号) {
				console.log(订单编号);
				this.$confirm('忽略'+订单编号+'提醒?', '长租合同到期待办忽略', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http
						.post('daiban/changzuhetong_hulue', {
							订单编号: 订单编号
						})
						.then(res => {
							if (res.代码 == '成功') {
								this.长租合同到期待办(this.长租合同到期待办当前页);
								this.$message.success(res.信息);
							} else {
								this.$message.error(res.信息);
							}
						});
				}).catch(() => {
					this.$message.info('已取消');
				});
			},
			长租合同到期待办(page) {
				this.长租合同到期待办当前页=page;
				this.$http
					.post('daiban/changzuhetong_daiban', {
						page: page
					})
					.then(response => {
						if (response.代码 == '权限错误') {
							this.隐藏长租合同到期待办 = false;
						} else if (response.代码 == '成功') {
							this.长租合同到期待办数据 = response;
						} else {
							console.log(response);
						}
					});
			},
			changzuhetong_daiban_tiaozhuan(val) {
				// 改变默认的页数
				// 切换页码时，要获取每页显示的条数
				this.长租合同到期待办(val);
			},
			我的应用() {
				this.$http.post('wodeyingyong/diannaoliulanqi').then(response => {
					this.应用数据 = response.数据;
					console.log(response);
				});
			},
			拖欠费用待办(page) {
				this.$http
					.post('daiban/tuoqianfeiyong', {
						page: page
					})
					.then(response => {
						if (response.代码 == '权限错误') {
							this.隐藏拖欠费用待办 = false;
						} else if (response.代码 == '成功') {
							this.拖欠费用数据 = response;
						} else {
							console.log(response);
						}
					});
			},
			tuoqianfeiyongdaiban_tiaozhuan(val) {
				// 改变默认的页数
				// 切换页码时，要获取每页显示的条数
				this.拖欠费用待办(val);
			},
			我的待办(page) {
				this.$http
					.post('daiban/wodedaiban', {
						page: page
					})
					.then(response => {
						if (response.代码 == '权限错误') {
							this.隐藏我的待办 = false;
						} else if (response.代码 == '成功') {
							this.我的待办数据 = response;
						} else {
							console.log(response);
						}
					});
			},
			wodedaiban_tiaozhuan(val) {
				// 改变默认的页数
				// 切换页码时，要获取每页显示的条数
				this.我的待办(val);
			},
			订单审核待办(page) {
				this.$http
					.post('daiban/dingdanshenhedaiban', {
						page: page
					})
					.then(response => {
						if (response.代码 == '权限错误') {
							this.隐藏订单审核待办 = false;
						} else if (response.代码 == '成功') {
							this.订单审核待办数据 = response;
						} else {
							console.log(response);
						}
					});
			},
			dingdanshenhedaiban_tiaozhuan(val) {
				// 改变默认的页数
				// 切换页码时，要获取每页显示的条数
				this.订单审核待办(val);
			},
			待排订单待办(page) {
				this.$http
					.post('daiban/daipaidingdandaiban', {
						page: page
					})
					.then(response => {
						if (response.代码 == '权限错误') {
							this.隐藏待排订单待办 = false;
						} else if (response.代码 == '成功') {
							this.待排订单待办数据 = response;
						} else {
							console.log(response.data);
						}
					});
			},
			daipaidingdandaiban_tiaozhuan(val) {
				// 改变默认的页数
				// 切换页码时，要获取每页显示的条数
				this.待排订单待办(val);
			},
			年审待办(page) {
				this.$http
					.post('daiban/nianshendaiban', {
						page: page
					})
					.then(response => {
						if (response.代码 == '权限错误') {
							this.隐藏年审待办 = false;
						} else if (response.代码 == '成功') {
							this.年审待办数据 = response;
						} else {
							console.log(response);
						}
					});
			},
			nianshendaiban_tiaozhuan(val) {
				// 改变默认的页数
				// 切换页码时，要获取每页显示的条数
				this.年审待办(val);
			},
			交强险待办(page) {
				this.$http
					.post('daiban/jiaoqiangxian_daiban', {
						page: page
					})
					.then(response => {
						if (response.代码 == '权限错误') {
							this.隐藏交强险待办 = false;
						} else if (response.代码 == '成功') {
							this.交强险待办数据 = response;
						} else {
							console.log(response);
						}
					});
			},
			jiaoqiangxian_daiban_tiaozhuan(val) {
				// 改变默认的页数
				// 切换页码时，要获取每页显示的条数
				this.交强险待办(val);
			},
			商业险待办(page) {
				this.$http
					.post('daiban/shangyexian_daiban', {
						page: page
					})
					.then(response => {
						if (response.代码 == '权限错误') {
							this.隐藏商业险待办 = false;
						} else if (response.代码 == '成功') {
							this.商业险待办数据 = response;
						} else {
							console.log(response);
						}
					});
			},
			shangyexian_daiban_tiaozhuan(val) {
				// 改变默认的页数
				// 切换页码时，要获取每页显示的条数
				this.商业险待办(val);
			},
			承运险待办(page) {
				this.$http
					.post('daiban/chengyunxian_daiban', {
						page: page
					})
					.then(response => {
						if (response.代码 == '权限错误') {
							this.隐藏承运险待办 = false;
						} else if (response.代码 == '成功') {
							this.承运险待办数据 = response;
						} else {
							console.log(response);
						}
					});
			},
			chengyunxian_daiban_tiaozhuan(val) {
				// 改变默认的页数
				// 切换页码时，要获取每页显示的条数
				this.承运险待办(val);
			},
			// 投保待办(page) {
			// 	this.$http
			// 		.post('daiban/toubaodaiban', {
			// 			page: page
			// 		})
			// 		.then(response => {
			// 			if (response.代码 == '权限错误') {
			// 				this.隐藏投保待办 = false;
			// 			} else if (response.代码 == '成功') {
			// 				this.投保待办数据 = response;
			// 			} else {
			// 				console.log(response);
			// 			}
			// 		});
			// },
			// toubaodaiban_tiaozhuan(val) {
			// 	// 改变默认的页数
			// 	// 切换页码时，要获取每页显示的条数
			// 	this.投保待办(val);
			// },
			/* GPS充值待办(page) {
				this.$http
					.post('daiban/gpschongzhidaiban', {
						page: page
					})
					.then(response => {
						if (response.代码 == '权限错误') {
							this.隐藏GPS充值待办 = false;
						} else if (response.代码 == '成功') {
							this.GPS充值待办数据 = response;
						} else {
							console.log(response);
						}
					});
			},
			gpschongzhidaiban_tiaozhuan(val) {
				// 改变默认的页数
				// 切换页码时，要获取每页显示的条数
				this.GPS充值待办(val);
			}, */
			/* 客户合同待办(page) {
				this.$http
					.post('daiban/kehuhetongdaiban', {
						page: page
					})
					.then(response => {
						if (response.代码 == '权限错误') {
							this.隐藏客户合同待办 = false;
						} else if (response.代码 == '成功') {
							this.客户合同待办数据 = response;
						} else {
							console.log(response);
						}
					});
			},
			kehuhetongdaiban_tiaozhuan(val) {
				// 改变默认的页数
				// 切换页码时，要获取每页显示的条数
				this.客户合同待办(val);
			} */
		}
	};
</script>

<style>
	body {
		margin: 0px;
	}

	#app {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}

	.el-header {
		background-color: #5a98de;
		color: #333;
		line-height: 40px;
	}

	.el-footer {
		background-color: #5a98de;
		line-height: 30px;
		color: #fff;
	}

	.home-container {
		height: 100%;
		width: 100%;
		position: absolute;
		left: 0px;
		right: 0px;
	}

	.dibu {
		height: 100%;
		width: 100%;
		background-color: #5a98de;
	}

	.el-row {
		margin-bottom: 20px;
		display: flex;
		flex-wrap: wrap;
	}

	.el-row .mianban {
		min-width: 100%;
		height: 100%;
		margin-right: 20px;
		transition: all 0.5s;
	}
</style>